const odoBrandOptions = [
    { id: "actual", label: "actual" },
    { id: "not_actual", label: "not_actual" },
    { id: "exempt", label: "exempt" },
    { id: "exceeds_mechanical_limits", label: "exceeds_mechanical_limits" }
];

  // API key
  const odoBrandAPIKey = "odobrand"; 
  
  // Label
  const odoBrandLabel = "Odobrand"; 
  
  export { odoBrandOptions, odoBrandAPIKey, odoBrandLabel };
  